<template>
  <div v-show="isAddVisible" id="EditNecesityTab">
    <div class="tag-badgeNeed ml-2 pb-3 mb-3">
      <span class="dotNeed text-center pt-1">
        <i class="fas fa-plus orange-icon" />
      </span>
      <span
        class="tag-badge-titleNeed pb-2 pt-md-2 pt-xl-0 mb-0 pl-2 text-center"
      >
        Añadir necesidades en el aprendizaje
      </span>
    </div>
    <div class="container-fluid bg-rectangle-gradiant" />

    <div class="container-fluid bg-gray">
      <div class="row">
        <select
          v-model="newRow.peiNecessityId"
          class="w-100 control-input mx-4 mt-2 mb-3"
          :class="{ invalidSelection: this.isInvalidSelection }"
          @change="changeSelection()"
        >
          <option value="0">
            Seleccionar
          </option>
          <option
            v-for="option in necessities"
            :key="option.index"
            :value="option.peiNecessityId"
          >
            {{ option.necessityName }}
          </option>
        </select>

        <div v-show="this.isInvalidSelection" class="col-11 ml-2 validation">
          <span class="error-val">
            <i class="fa fa-times-circle" aria-hidden="true" />
            Requerido
          </span>
        </div>

        <div
          v-if="this.newRow.peiNecessityId == otherOptionId"
          class="form-group w-100 mx-4 mt-2 pb-2"
        >
          <input
            v-model="newRow.otherName"
            placeholder="Especifique"
            type="text"
            maxlength="63"
            :disabled="atCompletedFlag"
            class="form-control input"
            :class="{ invalidDescription: this.isInvalidOtherName }"
          />
        </div>

        <div v-show="this.isInvalidOtherName" class="col-11 ml-2 validation">
          <span class="error-val">
            <i class="fa fa-times-circle" aria-hidden="true" />
            Requerido
          </span>
        </div>

        <h6>
          <span class="col-11 ml-2">
            Describa en qué consisten las necesidades que no pueden satisfacerse
            mediante los servicios descritos arriba. ¿Cómo afectan el desempeño
            escolar del estudiante?
          </span>
        </h6>

        <div class="form-group w-100 mx-4 mt-2 pb-2">
          <textarea
            v-model="newRow.description"
            class="form-control textarea-edge"
            rows="4"
            :maxlength="limit"
            :class="{ invalidDescription: this.isInvalidDescription }"
          />
        </div>

        <div v-show="this.isInvalidDescription" class="col-11 ml-2 validation">
          <span class="error-val">
            <i class="fa fa-times-circle" aria-hidden="true" />
            Requerido
          </span>
        </div>

        <div class="d-flex flex-row-reverse bd-highlight w-100 pr-3 mb-5">
          <div class="mx-0 bd-highlight mx-2">
            <button
              id="btnFA"
              class="btn btn-action btn-green"
              @click="addNecessity"
            >
              <i class="fas fa-file-plus pr-2" />
              {{ this.newRow.editing ? 'Modificar' : 'Añadir' }}
            </button>
          </div>
          <div class="mx-0 bd-highlight">
            <button id="btnFA" class="btn btn-outline-red" @click="closeModal">
              <i class="fas fa-times-circle text-red pr-1" />
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonValues } from '@/utils/constants/at/common';
import store from '@/store/index';

export default {
  props: {
    isAddVisible: {
      type: Boolean,
      default: false,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
    necessities: {
      type: Array,
      required: true,
    },
    limit: {
      type: Number,
      default: 3000,
    },
  },
  data() {
    return {
      isInvalidSelection: false,
      isInvalidDescription: false,
      isInvalidOtherName: false,
      enableOtherName: false,
      newRow: {},
      otherOptionId: commonValues.OTHER_OPTION_NECESSITY_ID,
    };
  },
  watch: {
    row: function(newRow) {
      this.newRow = Object.assign({}, newRow);
    },
  },
  methods: {
    cleanValidation() {
      this.isInvalidDescription = false;
      this.isInvalidSelection = false;
      this.isInvalidOtherName = false;
    },
    closeModal() {
      this.cleanValidation();
      this.enableOtherName = false;
      this.$emit('close');
    },
    addNecessity() {
      if (this.isValid()) {
        if (!this.newRow.isNew) {
          this.newRow.modified = true;
        }

        this.$emit('addNecessity', this.newRow);
      }
    },
    isValid() {
      let valid = true;

      if (this.newRow.peiNecessityId == 0) {
        this.isInvalidSelection = true;
        valid = false;
      }

      if (this.newRow.description.length === 0) {
        this.isInvalidDescription = true;
        valid = false;
      }

      if (this.enableOtherName && this.newRow.otherName.length === 0) {
        this.isInvalidOtherName = true;
        valid = false;
      }

      return valid;
    },
    changeSelection() {
      this.isInvalidSelection = false;
      this.isInvalidOtherName = false;

      if (this.newRow.peiNecessityId == this.otherOptionId) {
        this.enableOtherName = true;
      } else {
        this.enableOtherName = false;
        this.newRow.otherName = '';
      }

      const necessity = this.necessities.filter(
        (x) => x.peiNecessityId == this.newRow.peiNecessityId
      );

      if (necessity.length > 0) {
        this.newRow.necessityName = necessity[0].necessityName;
      }
    },
    validateReadMode() {
      if (!this.atCompletedFlag) {
        return;
      }

      const tags = ['input', 'button', 'textarea', 'select'];
      tags.forEach((tagName) => {
        const nodes = document
          .getElementById('EditNecesityTab')
          .getElementsByTagName(tagName);

        for (let i = 0; i < nodes.length; i++) {
          nodes[i].disabled = true;
          nodes[i].tabIndex = -1;

          if (tagName == 'button') {
            nodes[i].style.display = 'none';
          }
        }
      });
    },
  },
  mounted() {
    this.validateReadMode();
  },
  computed: {
    atCompletedFlag() {
      return store.getters.getAtCompleted;
    },
  },
};
</script>
<style scoped>
.error-val {
  color: #ff5b5c;
}

.invalidSelection,
.invalidDescription {
  border-color: #ff5b5c;
}

.validation {
  margin-bottom: 10px;
}
</style>
